import { IDecisionResultDecisionForm } from 'DecisionPackage/MainModule/interfaces/IDecisionResultDecisionForm';
import { IDecisionResultDecision } from 'APIPackage/DecisionModule/interfaces/IDecisionResultDecision';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { convertViolatedRequirementsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertViolatedRequirementsFormValuesToKnmData';
import { IKnmActFamiliarizationNotifications } from 'APIPackage/KnmModule/interfaces/IKnmActFamiliarizationNotifications';
import { store } from 'CorePackage/MainModule/common/store';
import { getDirtyResultDecisionGuid } from 'CorePackage/HeaderModule/reducers/headerReducer';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';
import { convertDecisionOrganizationFormValuesToDecisionData } from './convertDecisionOrganizationFormValuesToDecisionData';
import { convertFormDateTimeValueToKnmDataDate } from '../../../KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';
import { convertSignersFormToData } from '../../../KnmErknmPackage/MainModule/common/convertSignersFormToData';

export const convertDecisionResultFormValuesToData = (
  {
    status,
    kind,
    notes,
    injunction,
    date,
    dateResolvedByAgreement,
    number,
    fioSigner,
    titleSigner,
    document,
    eliminatedMandatoryRequirements,
    guid,
    signed,
    paperless,
    extractVersion,
    familiarizationNotifications,
    firstExtractDateTime,
    agreementStatus,
    systemSignatureUsed,
    systemSignatureMnemonic,
    systemSignatureTitle,
    systemSignatureDateTime,
    cancelComment,
    cancelFioSigner,
    cancelTitleSigner,
    cancelDocument,
    isCancelSigned,
    isNew,
    founder,
    subjectType,
    dateAdded,
    signers,
  }: IDecisionResultDecisionForm,
  isDraft: boolean | undefined,
): IDecisionResultDecision => {
  const state = store.getState();
  const dirtyResultDecisionGuid = getDirtyResultDecisionGuid(state);

  return {
    isNew: isDraft ? !!isNew : null,
    agreementStatus: agreementStatus || null,
    dateResolvedByAgreement: convertFormDateTimeValueToKnmDataDate(dateResolvedByAgreement, true) || null,
    date: convertFormDateTimeValueToKnmDataDate(date, true) || null,
    document: document
      ? {
          active: document.active || null,
          attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(document.attachments),
          correlationToken: document.correlationToken || null,
          description: document.description || null,
          guid: document.guid || null,
          type: document.type || null,
        }
      : null,
    fioSigner: fioSigner || null,
    guid: guid || null,
    injunction: injunction
      ? {
          dateResolved: convertFormDateValueToKnmDataDate(injunction.dateResolved),
          note: injunction.note || null,
          noteReactQuillEditor: handleReactQuillDeltaValue(injunction.noteReactQuillEditor || injunction.note),
          guid: injunction.guid || null,
          dateCreate: injunction.dateCreate || null,
        }
      : null,
    kind: kind ? deleteObjectProperties(kind, ['label', 'value']) : null,
    noteLawsuits:
      notes?.map(note => ({
        value: note.value || null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        valueReactQuillEditor: handleReactQuillDeltaValue(note.valueReactQuillEditor || note.value) as any,
        guid: note.guid || null,
        dateCreate: note.dateCreate || null,
      })) || null,
    number: number || null,
    status: status || null,
    titleSigner: titleSigner?.value || null,
    violations: convertViolatedRequirementsFormValuesToKnmData(eliminatedMandatoryRequirements, isDraft),
    signed: dirtyResultDecisionGuid && dirtyResultDecisionGuid === guid ? false : signed ?? null,
    paperless: paperless || null,
    extractVersion: extractVersion || null,
    familiarizationNotifications:
      familiarizationNotifications?.map(x => {
        const notification: IKnmActFamiliarizationNotifications = {
          noticeDate: convertFormDateValueToKnmDataDate(x.noticeDate),
          knmNoticeType: x.knmNoticeType || null,
          note: x.note || null,
          guid: x.listId,
          isNew: x.isNew,
          existedAtSigning: x.existedAtSigning || null,
        };

        return notification;
      }) || null,
    dateDecision: null,
    firstExtractDateTime: convertFormDateTimeValueToKnmDataDate(firstExtractDateTime, false) || null,
    systemSignatureUsed: systemSignatureUsed || false,
    systemSignatureTitle: systemSignatureTitle || null,
    systemSignatureMnemonic: systemSignatureMnemonic || null,
    systemSignatureDateTime: systemSignatureDateTime || null,
    cancelComment: cancelComment || null,
    cancelFioSigner: !cancelFioSigner ? state.knm.prescribeDataForSign?.fioSigner || null : cancelFioSigner,
    cancelTitleSigner: cancelTitleSigner?.value
      ? cancelTitleSigner?.value
      : state.knm.prescribeDataForSign?.signerPosition?.value || null,
    cancelDocument: convertKnmDocumentAttachmentsFormValuesToKnmData([cancelDocument])?.pop() || null,
    isCancelSigned: isCancelSigned || null,
    founder: founder ? convertDecisionOrganizationFormValuesToDecisionData(founder) : null,
    subjectType: subjectType?.value || null,
    dateAdded: dateAdded || null,
    signers: convertSignersFormToData(signers),
  };
};
